import React, { useEffect } from "react";

import { logout } from "../../slices/current";
import { useDispatch } from "../../store";

export const Logout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(logout());
  }, []);

  return <></>;
};
